import type { FinanceType } from '@kanda-libs/ks-frontend-services';

interface FinanceOption {
  name: string;
  fee: number;
  charge: number;
  enabled: boolean;
  finance_types: FinanceType[];
  provider: 'omni' | 'etika' | 'propensio' | 'allium' | 'humm' | 'demo';
}

export const DECLINE_FINANCE_OPTION: FinanceOption = {
  name: 'decline',
  fee: 0,
  charge: 0,
  enabled: true,
  finance_types: ['primary'],
  provider: 'demo',
};

export const PROVIDERS = {
  omni: 'Omni Capital Retail Finance',
  allium: 'Tandem Bank',
  propensio: 'Propensio Finance Limited',
  etika: 'Etika Finance UK Limited',
  humm: 'Humm Group Limited',
  demo: 'Kanda Finance UK Limited',
  unknown: 'Unknown',
};
